import React from "react";

const NOS = ["Reorganizar", "Interpretar", "Revisar premissas", "Perceber", "Observar efeitos", "Relacionar"];
const FATORES = [
    [-90, "mudanças econômicas e políticas"], [-35, "novas informações"], [15, "rupturas"],
    [90, "mudanças tecnológicas"], [165, "fatores humanos"], [215, "mudanças ambientais"],
];
const rad = (d) => (d * Math.PI) / 180;
const anchor = (c) => (c > 0.6 ? "start" : c < -0.6 ? "end" : "middle");

const Rede = ({ cx, cy, rx, ry, fs, fatores, mid }) => {
    const pts = NOS.map((t, i) => {
        const a = rad(i * 60);
        return { t, a, x: cx + rx * Math.cos(a), y: cy + ry * Math.sin(a) };
    });
    const pares = pts.flatMap((p, i) => pts.slice(i + 1).map((q) => [p, q]));
    return (
        <>
            <defs>
                <marker id={mid} viewBox="0 0 10 10" refX="5" refY="5" markerWidth="4" markerHeight="4" orient="auto-start-reverse">
                    <path d="M0,0 L10,5 L0,10 z" fill="#8a6a22" />
                </marker>
            </defs>
            {fatores && FATORES.map(([g, t]) => {
                const a = rad(g), c = Math.cos(a), s = Math.sin(a);
                const at = (k) => [cx + 340 * k * c, cy + 225 * k * s];
                const [x1, y1] = at(0.86), [x2, y2] = at(0.7), [lx, ly] = at(1);
                return (
                    <g key={t}>
                        <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="#8a6a22" strokeOpacity="0.55" strokeDasharray="3 4" markerEnd={`url(#${mid})`} />
                        <text x={lx} y={ly + 4} textAnchor={anchor(c)} fontSize="15" letterSpacing="1" fill="#5b6658" className="font-sans uppercase">{t}</text>
                    </g>
                );
            })}
            {pares.map(([p, q]) => (
                <path key={p.t + q.t} d={`M${p.x},${p.y} Q${(p.x + q.x) / 2 + (cy - (p.y + q.y) / 2) * 0.18},${(p.y + q.y) / 2 + ((p.x + q.x) / 2 - cx) * 0.18} ${q.x},${q.y}`}
                    fill="none" stroke="#0E2018" strokeOpacity="0.13" />
            ))}
            {pts.map((p, i) => {
                const q = pts[(i + 1) % pts.length];
                const sx = p.x + (q.x - p.x) * 0.14, sy = p.y + (q.y - p.y) * 0.14;
                const ex = p.x + (q.x - p.x) * 0.86, ey = p.y + (q.y - p.y) * 0.86;
                const mx = (p.x + q.x) / 2, my = (p.y + q.y) / 2;
                const kx = mx + (mx - cx) * 0.16, ky = my + (my - cy) * 0.16;
                return (
                    <path key={`r-${p.t}`} data-testid="mapa-retorno" d={`M${sx},${sy} Q${kx},${ky} ${ex},${ey}`} fill="none"
                        stroke="#8a6a22" strokeOpacity="0.45" markerStart={`url(#${mid})`} markerEnd={`url(#${mid})`} />
                );
            })}
            {pts.map((p) => (
                <line key={p.t} x1={p.x + (cx - p.x) * 0.12} y1={p.y + (cy - p.y) * 0.12} x2={p.x + (cx - p.x) * 0.62} y2={p.y + (cy - p.y) * 0.62}
                    stroke="#8a6a22" strokeOpacity="0.6" markerStart={`url(#${mid})`} markerEnd={`url(#${mid})`} />
            ))}
            <ellipse cx={cx} cy={cy} rx={rx * 0.34} ry={ry * 0.32} fill="#C7A659" fillOpacity="0.12" stroke="#8a6a22" strokeOpacity="0.35" strokeDasharray="2 4" />
            <text x={cx} y={cy - fs * 0.15} textAnchor="middle" fontSize={fs * 0.82} fill="#0E2018" className="font-serif italic">Sistema em</text>
            <text x={cx} y={cy + fs * 0.85} textAnchor="middle" fontSize={fs * 0.82} fill="#0E2018" className="font-serif italic">transformação</text>
            {pts.map((p) => {
                const c = Math.cos(p.a), s = Math.sin(p.a), side = Math.abs(c) > 0.6;
                return (
                    <g key={`n-${p.t}`}>
                        <circle cx={p.x} cy={p.y} r="5" fill="#F2EFE5" stroke="#8a6a22" strokeWidth="1.5" />
                        <text x={p.x + (side ? 14 * Math.sign(c) : 0)} y={p.y + (side ? fs * 0.35 : s > 0 ? fs * 1.4 : -fs * 0.8)}
                            textAnchor={anchor(c)} fontSize={fs} fill="#0E2018" className="font-serif">{p.t}</text>
                    </g>
                );
            })}
        </>
    );
};

export const MapaAprendizagem = () => (
    <figure data-testid="disciplina-mapa" aria-label={`Mapa não linear: ${NOS.join(", ")} em torno de um sistema em transformação, com retroalimentações entre os elementos`}>
        <svg viewBox="-40 0 980 500" className="hidden md:block w-full h-auto" role="img" aria-hidden="false">
            <Rede cx={450} cy={255} rx={210} ry={135} fs={20} fatores mid="mapa-seta-d" />
        </svg>
        <svg viewBox="-10 20 560 320" className="md:hidden w-full h-auto" role="img">
            <Rede cx={270} cy={180} rx={160} ry={110} fs={18} mid="mapa-seta-m" />
        </svg>
        <p data-testid="mapa-fatores-mobile" className="md:hidden mt-4 font-sans text-[10.5px] uppercase tracking-[0.18em] leading-[1.9] text-[#5b6658]">
            Fatores que alteram o sistema: {FATORES.map(([, t]) => t).join(" · ")}
        </p>
    </figure>
);
